import React from "react";
import { createUseStyles } from "react-jss";
import { CDN_URL } from "Constants/CDN";

const useStyles = createUseStyles((theme) => ({
	text: {
		padding: 0,
		margin: "20px 0",
		minHeight: "32px",
		fontFamily: theme.fonts.bold,
		fontSize: "32px",
		lineHeight: "1",
		textAlign: "center",
		color: theme.palette.colors.white,
		wordWrap: "break-word",
		zIndex: "1",
	},
	containerCat: {
		width: "100%",
		marginBottom: "30px",
	},
	cat: {
		width: "35%",
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		cat: {
			width: "50%",
		},
		text: {
			fontSize: "28px",
			minHeight: "28px",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		cat: {
			width: "50%",
		},
		text: {
			fontSize: "24px",
			minHeight: "24px",
		},
	},
	[`@media (max-width: 500px)`]: {
		cat: {
			width: "80%",
		},
	},
}));

const PageTitle404Header = (props) => {
	const classes = useStyles();
	return (
		<>
			<div className={classes.containerCat}>
				<img className={classes.cat} src={`${CDN_URL}/images/qrator/404.png`} alt="404" />
			</div>
			<h1 className={classes.text}>{props.texth1}</h1>
		</>
	);
};

export default PageTitle404Header;
